import React from 'react';
import { Dimensions, Platform, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import DatePicker from '../../../shared/components/datepicker/index';
import { setCurrentSeverity, setCurrentTime } from '../actions';
import Moment from 'moment';
import Slider from '../../../shared/components/Slider';
import { Icon, Spacer, Text } from '../../../design/components';
import strings from '../strings';
import setTestID from '../../../shared/utilities/setTestID';
import { localeMoment } from '../../../shared/utilities/timeutils';
import { trackTimeChange } from '../../../shared/utilities/answers';
import Button from '../../../design/components/Button';
import { designConstants } from '../../../design/styles';
import GuidingArrow from '../../../design/components/GuidingArrow';
import { toSentenceCase } from '../../../shared/utilities/stringsutils';
import DateText from '../../../shared/components/DateText';
import { withTheme } from '../../../design/styles/useThemeContext';

// Trying to use new severity slider to provide better performance
class SeveritySliderComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      innerSeverity: props.currentSeverity,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.currentSeverity !== nextProps.currentSeverity) {
      this.setState({ innerSeverity: nextProps.currentSeverity });
    }
  }

  componentDidMount() {
    // if(this.props.time_draft) {
    //   setTimeout(() => {
    //     this._datepicker?.onPressDate();
    //   }, 500);
    // }
  }
  onDatePicked = (date) => {
    trackTimeChange('pain_record');
    console.log('ON DATE PICKED', date);
    date = Moment(date).valueOf();
    console.log('ON DATE PICKED2', date);
    this.props.dispatch(setCurrentTime(date));
  };

  getHowIsYourPain() {
    var datePicker = null;
    var timePicker = null;
    var dateLabel = null;
    var timeLabel = <Text key={'datepicker_timelabel'} />;
    let dateTime =
      typeof this.props.recordTime !== 'undefined'
        ? Moment(this.props.recordTime)
        : Moment();

    dateTime = localeMoment(dateTime);
    let isRightNow =
      typeof this.props.recordTime === 'undefined' ||
      Math.abs(Moment().diff(Moment(this.props.recordTime), 'minute')) < 5;
    let isToday = dateTime.isSame(Moment(), 'day');
    let isInPast = Moment().diff(dateTime, 'minutes') > 5;

    const colors = this.props.theme.colors;
    //TODO: how is your pain/how was you pain poorly translated
    //ko and zh still not implemented here
    let howIsYourPain = isToday
      ? strings.severity_slider_how_is_your_pain_today
      : strings.severity_slider_how_is_your_pain_at_date;
    let howWasYourPain = isToday
      ? strings.severity_slider_how_was_your_pain_today
      : strings.severity_slider_how_was_your_pain_at_date;

    timePicker = (
      <DatePicker
        ref={(picker) => {
          this._timepicker = picker;
        }}
        resettable
        key="timepicker"
        date={dateTime.toDate()}
        mode="time"
        onDateChange={(str, date) => this.onDatePicked(date)}
      >
        <View style={{ height: 28 }} />
      </DatePicker>
    );

    datePicker = (
      <DatePicker
        ref={(picker) => {
          this._datepicker = picker;
        }}
        resettable
        key="datepicker_rightnow"
        date={dateTime.toDate()}
        mode={Platform.OS === 'android' ? 'date' : 'datetime'}
        onDateChange={(str, date) => {
          this.onDatePicked(date);
          if (Platform.OS === 'android') {
            this._timepicker?.onPressDate();
          }
        }}
      >
        <View style={{ height: 28 }} />
      </DatePicker>
    );

    if (isRightNow) {
      howIsYourPain = strings.severity_slider_how_is_your_pain;

      Platform.OS === 'android' &&
        (timePicker = (
          <DatePicker
            ref={(picker) => {
              this._timepicker = picker;
            }}
            resettable
            key="timepicker_rightnow"
            date={dateTime.toDate()}
            mode="time"
            onDateChange={(str, date) => {
              this.onDatePicked(date);
            }}
          >
            <View style={{ height: 28 }} />
          </DatePicker>
        ));
      dateLabel = (
        <Text
          style={{
            textAlignVertical: 'auto',
          }}
        >
          {strings.severity_slider_right_now_label}
        </Text>
      );
    } else if (isToday) {
      dateLabel = (
        <Text
          bold
          style={{
            textAlignVertical: 'bottom',
            color: colors.textSecondary,
          }}
        >
          {strings.severity_slider_today_label}
        </Text>
      );
      timeLabel = (
        <DateText
          bold
          date={dateTime}
          timeFormat={'short'}
          style={{
            textAlignVertical: 'bottom',
            color: colors.textSecondary,
          }}
        />
      );
    } else {
      dateLabel = (
        <DateText
          key={'text_dateLabel'}
          bold
          date={dateTime}
          dateFormat={'medium'}
          style={{
            textAlignVertical: 'bottom',
            color: colors.textSecondary,
          }}
        />
      );
      timeLabel = (
        <DateText
          key={'text_timeLabel'}
          bold
          date={dateTime}
          timeFormat={'short'}
          style={{
            textAlignVertical: 'bottom',
            color: colors.textSecondary,
          }}
        />
      );
    }

    let str = isInPast ? howWasYourPain : howIsYourPain;
    //        str = str.split(/{\d}/);
    return [
      <Text key={'text_1'} style={{ alignSelf: 'center', textAlign: 'center' }}>
        {strings.formatString(str, dateLabel, timeLabel)}
      </Text>,
      <Button
        outlined
        onPress={() => {
          this._datepicker?.onPressDate();
        }}
        style={styles.changeDateButton}
      >
        <Icon
          type="MaterialCommunityIcons"
          name="calendar"
          color={colors.buttonBlue}
          size={18}
          style={{ marginRight: 4 }}
        />
        <Text medium blue>
          {toSentenceCase(strings.severity_slider_change_date_time)}
        </Text>
      </Button>,
      datePicker,
      timePicker,
    ];
  }

  // This is needed to update severity circle, but not to update actual severity value in store
  // Value of slider will be updated only on slide stop
  // Rendering on every sliding needs too much resources
  setInnerSeverity = (newInnerSeverity) => {
    const { innerSeverity } = this.state;
    // if (Math.abs(innerSeverity - newInnerSeverity) < 9) {
    //     return;
    // }
    this.setState({ innerSeverity: newInnerSeverity });
    if (this.props.sliding) {
      this.props.sliding(true);
    }
  };

  onSeverityChange = (value) => {
    this.setState({ innerSeverity: value });
    this.props.dispatch(setCurrentSeverity(value));
    if (this.props.sliding) {
      this.props.sliding(false);
    }
  };

  onSliderTouched = () => {
    if (this.props.onSliderTouched) {
      this.props.onSliderTouched();
    }
  };

  render() {
    const { innerSeverity } = this.state;
    const windowWidth = Dimensions.get('window').width;
    const showCTA = this.props.showCTA;
    const { colors } = this.props.theme;

    return (
      <View
        style={[
          styles.container,
          { direction: 'ltr', backgroundColor: colors.defaultBackground },
        ]}
        direction={'ltr'}
      >
        <View
          style={{
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'center',
            paddingBottom: 15,
            paddingLeft: 28,
            paddingRight: 28,
          }}
        >
          {this.getHowIsYourPain()}
        </View>
        <View
          style={{
            alignSelf: 'stretch',
            marginTop: 10,
          }}
        >
          {showCTA && (
            <>
              <GuidingArrow
                style={{
                  position: 'absolute',
                  left: 70,
                  bottom: 45,
                }}
              />
              <View
                style={{
                  position: 'absolute',
                  maxWidth: windowWidth - 170,
                  left: 160,
                  bottom: 52,
                }}
              >
                <Text
                  style={{
                    fontFamily: 'Caveat-Regular',
                    fontSize: 26,
                    width: '100%', // Otherwise the last character will be cut off (some Caveat font issue).
                  }}
                >
                  {strings.severity_slider_drag_this_slider}
                </Text>
              </View>
            </>
          )}
          <Slider
            {...setTestID('severity_slider_' + this.props.screen)}
            accessible={true}
            onValueChange={this.setInnerSeverity}
            onSlidingComplete={this.onSeverityChange}
            onSlidingStart={this.onSliderTouched}
            minimumValue={0}
            maximumValue={10}
            step={0.1}
            trackClickable={true}
            value={innerSeverity}
            mode="severity"
          />
          <View
            style={{
              alignSelf: 'stretch',
              paddingHorizontal: 30,
              marginTop: -5,
              flexDirection: 'row',
              direction: 'ltr',
            }}
            direction={'ltr'}
          >
            <Text small gray>
              {strings.severity_slider_0_slider_label}
            </Text>
            <Spacer />
            <Text small gray>
              {strings.severity_slider_10_slider_label}
            </Text>
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    paddingTop: designConstants.paddings.edgePadding,
    paddingBottom: designConstants.paddings.edgePadding,
  },
  changeDateButton: {
    marginHorizontal: designConstants.paddings.edgePadding,
    marginVertical: designConstants.paddings.edgePadding,
  },
});
const mapStateToProps = (state) => {
  if (state.records && state.records.current && state.records.current.record) {
    return {
      recordTime: state.records.current.record.recordTime,
      time_draft: state.records.current.record.time_draft,
      lastRecord: state.records.current.lastRecordId,
      //record: state.records.current.record, // record is not needed for slider, but requires resourses on
      // unnecessary rendering
      currentSeverity: state.records.current.record.severity,
    };
  } else {
    return {
      lastRecord:
        state.records &&
        state.records.current &&
        state.records.current.lastRecordId,
    };
  }
};

export default connect(mapStateToProps)(withTheme(SeveritySliderComponent));
